// CONSTANTS are all caps.
const NS = "ContactUsSearchBlock";
const CLS = "contactUsSearchBlock";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/contactUsSearchBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class ContactUsSearchBlock {

	constructor($el) {
		// $el is the widget node return by the loadContactUsSearchBlock function
		this.$el = $el;
	}

	init() {
		//this.setContactUsSearchBlock();
		this.setCountryList();
		this.handleCountryOnSelect();
	}

	setContactUsSearchBlock() {
		const wg = this.$el;

		const input = wg.querySelector(WG + 'inp');
		const searchResults = wg.querySelector(WG + 'results');
		const searchIndex = wg.querySelector(WG + 'searchWrapper').getAttribute('data-offices').split(',');

		let inputTerms, termsArray, prefix, terms, results, sortedResults;


		const search = function () {
			inputTerms = input.value.toLowerCase();
			results = [];
			termsArray = inputTerms.split(' ');
			prefix = termsArray.length === 1 ? '' : termsArray.slice(0, -1).join(' ') + ' ';
			terms = termsArray[termsArray.length - 1].toLowerCase();

			for (let i = 0; i < searchIndex.length; i++) {
				const a = searchIndex[i].toLowerCase(),
					t = a.indexOf(terms);

				if (t > -1) {
					results.push(a);
				}
			}

			evaluateResults();
		};

		const evaluateResults = function () {
			if (results.length > 0 && inputTerms.length > 0 && terms.length !== 0) {
				sortedResults = results.sort(sortResults);
				appendResults();
			}
			else if (inputTerms.length > 0 && terms.length !== 0) {
				searchResults.innerHTML = '<div>Sorry, <strong>'
					+ inputTerms
					+ '</strong> has not results.</div>';

			}
			else if (inputTerms.length !== 0 && terms.length === 0) {
				return;
			}
			else {
				clearResults();
				//Remove 'has-results' class
				searchResults.className = CLS+"-results";
			}
		};

		const sortResults = function (a, b) {
			if (a.indexOf(terms) < b.indexOf(terms)) return -1;
			if (a.indexOf(terms) > b.indexOf(terms)) return 1;
			return 0;
		};

		const appendResults = function () {
			clearResults();

			for (let i = 0; i < sortedResults.length && i < 5; i++) {
				const resultItem = document.createElement("div");
				resultItem.className = CLS+'-result';

				resultItem.innerHTML = prefix
					+ sortedResults[i].toLowerCase().replace(terms, '<strong>'
						+ terms
						+ '</strong>');
				searchResults.appendChild(resultItem);
				resultItem.addEventListener('click', selectResult, false);
			}

		};

		const clearResults = function () {
			searchResults.className = CLS+"-results has-results";
			searchResults.innerHTML = '';
		};

		const selectResult = function (e) {
			const selected = e.currentTarget.innerText;
			input.value = selected;
			//search();
			clearResults();
			input.focus();
		};

		input.addEventListener("keyup", search, false);




	}

	setCountryList() {
		let input = this.$el.querySelector(WG + 'inp');
		let list = [];
		let items = this.$el.querySelectorAll(WG + 'countryList li');

		$.each(items, (i, item) => {
			list.push({
				label: $(item).text(),
				value: $(item).data('value')
			});
		});

		new Awesomplete(input, {
			list: list,
			minChars: 1,
			autoFirst: true,
		});
	}

	handleCountryOnSelect() {
		let input = this.$el.querySelector(WG + 'inp');
		input.addEventListener('awesomplete-selectcomplete', (event) => {
			let $mapList = $('[data-wg="ContactUsLocation"]');
			let selCountry = event.text.value;

			//show/hide ContactUsLocation widget
			$mapList.addClass('d-none');

			$.each($mapList, (i, map) => {
				let $map = $(map);
				let countries = $map.data('country').split(',');

				//match map value with dropdown value
				$.each(countries, (i, country) => {
					if(selCountry === country) {
						$map.removeClass('d-none');
					}
				});
			});
		});
	}

	//Add more functions like on above here

}
